import React, { Component } from "react";
import { injectIntl } from "react-intl";

import "wxrecall/components/SearchInput.css";
import WeatherSearchInput from "wxrecall/components/WeatherSearchInput";
import BulletinSearchInput from "wxrecall/components/BulletinSearchInput";
import { defaultSettings } from "wxrecall/util/defaults";
import If from "common/components/if";

const settings = window.settings || defaultSettings;

export class SearchInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tab: "weather"
    };
  }

  componentDidUpdate = (prevProps, prevState, snapshot) => {
    if (prevProps.tab !== this.props.tab) {
      this.props.searchCallback([]);
    }
  };

  toggle = tab => {
    this.props.toggleTab(tab);
  };

  render() {
    let content = "";

    if (this.props.tab === "weather") {
      content = (
        <WeatherSearchInput
          addMessage={this.props.addMessage}
          networkManager={this.props.networkManager}
          updateRequestState={this.props.updateRequestState}
          searchCallback={this.props.searchCallback}
          setPreferredLanguage={this.props.setPreferredLanguage}
          setCollapseDuplicates={this.props.setCollapseDuplicates}
          restoreDefaults={this.props.restoreDefaults}
        />
      );
    } else if (this.props.tab === "bulletin") {
      content = (
        <BulletinSearchInput
          networkManager={this.props.networkManager}
          updateRequestState={this.props.updateRequestState}
          searchCallback={this.props.searchCallback}
        />
      );
    }

    return (
      <div className="search-input">
        <div className="search-input-tabs">
          <If condition={!!settings.canSeeBulletinSearch}>
            <ul className="nav nav-tabs">
              <li className={this.props.tab === "weather" ? "active" : ""}>
                <a onClick={this.toggle.bind(this, "weather")}>
                  {this.props.intl.formatMessage({
                    id: "weather_tab"
                  })}
                </a>
              </li>
              <li className={this.props.tab === "bulletin" ? "active" : ""}>
                <a onClick={this.toggle.bind(this, "bulletin")}>
                  {this.props.intl.formatMessage({
                    id: "bulletin_tab"
                  })}
                </a>
              </li>
            </ul>
          </If>
        </div>
        <div className="search-input-content">{content}</div>
      </div>
    );
  }
}

export default injectIntl(SearchInput);
